module.exports = __webpack_public_path__ + "img/Star_line.2995ed72.svg";